// src/services/companyService.js
import api from './api';

const companyService = {
  // Récupérer toutes les compagnies avec filtres et pagination
  getCompanies: async (params = {}) => {
    const response = await api.get('/companies', { params });
    return response.data;
  },
  
  // Récupérer une compagnie par son ID
  getCompanyById: async (id) => {
    const response = await api.get(`/companies/${id}`);
    return response.data;
  },
  
  // Créer une nouvelle compagnie
  createCompany: async (companyData) => {
    // Si companyData contient un logo (fichier), utiliser FormData
    if (companyData.logo && companyData.logo instanceof File) {
      const formData = new FormData();
      
      // Ajouter tous les champs au formData
      Object.keys(companyData).forEach(key => {
        if (key === 'logo') {
          formData.append('logo', companyData.logo);
        } else if (key === 'socialMedia' && typeof companyData[key] === 'object') {
          // Pour les objets, les ajouter en tant que JSON
          formData.append(key, JSON.stringify(companyData[key]));
        } else {
          formData.append(key, companyData[key]);
        }
      });
      
      const response = await api.post('/companies', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data;
    } else {
      const response = await api.post('/companies', companyData);
      return response.data;
    }
  },
  
  // Mettre à jour une compagnie existante
  updateCompany: async (id, companyData) => {
    // Si companyData contient un logo (fichier), utiliser FormData
    if (companyData.logo && companyData.logo instanceof File) {
      const formData = new FormData();
      
      // Ajouter tous les champs au formData
      Object.keys(companyData).forEach(key => {
        if (key === 'logo') {
          formData.append('logo', companyData.logo);
        } else if (key === 'socialMedia' && typeof companyData[key] === 'object') {
          // Pour les objets, les ajouter en tant que JSON
          formData.append(key, JSON.stringify(companyData[key]));
        } else {
          formData.append(key, companyData[key]);
        }
      });
      
      const response = await api.put(`/companies/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data;
    } else {
      const response = await api.put(`/companies/${id}`, companyData);
      return response.data;
    }
  },
  
  // Supprimer une compagnie
  deleteCompany: async (id) => {
    const response = await api.delete(`/companies/${id}`);
    return response.data;
  },
};

export default companyService;